import { render, staticRenderFns } from "./GDproView.vue?vue&type=template&id=446720b2&scoped=true&"
import script from "./GDproView.vue?vue&type=script&lang=js&"
export * from "./GDproView.vue?vue&type=script&lang=js&"
import style0 from "./GDproView.vue?vue&type=style&index=0&id=446720b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446720b2",
  null
  
)

export default component.exports